import { ReactNode, useEffect, useRef, useId } from "react";
import { createPortal } from "react-dom";

/** In-flow editor: normal document scrolling, explicit return, and Escape support. */
export function ToolModal({ title, close, children }: { title: string; close: () => void; children: ReactNode }): React.JSX.Element {
  const editor = useRef<HTMLElement>(null), id = useId();
  const opener = useRef(typeof document === "undefined" ? null : document.activeElement);
  useEffect(() => {
    const previous = opener.current;
    editor.current?.focus();
    editor.current?.scrollIntoView({ block: "start" });
    // Wait for the portal to unmount and the underlying list to become visible.
    return () => { requestAnimationFrame(() => { if (previous instanceof HTMLElement && previous.isConnected) previous.focus(); }); };
  }, []);
  const content = <section className="tool-editor" ref={editor} tabIndex={-1} aria-labelledby={id} onKeyDown={event => { if (event.key === "Escape" && !event.defaultPrevented) { event.preventDefault(); close(); } }}><header className="tool-editor-header"><h2 id={id}>{title}</h2><button type="button" onClick={close}>{typeof document !== "undefined" && document.documentElement.lang === "es" ? "← Volver" : "← Back"}</button></header>{children}</section>;
  const host = typeof document === "undefined" ? null : document.getElementById("company-editor-host") ?? document.getElementById("admin-editor-host");
  return host ? createPortal(content, host) : content;
}
